import { Apple, Play } from "lucide-react";

// "Coming Soon" store buttons — premium but clearly disabled.
export const StoreButtons = ({ className = "", size = "default" }) => {
  const pad = size === "lg" ? "px-6 py-4" : "px-5 py-3.5";
  return (
    <div className={`flex flex-col sm:flex-row gap-3 ${className}`}>
      <a
        href="https://play.google.com/store/apps/details?id=com.renewtracker.app"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="google-play-btn"
        aria-label="Get RenewTracker on Google Play"
        className={`group relative flex items-center gap-3 rounded-2xl bg-ink text-white ${pad} shadow-sm transition-transform duration-200 hover:-translate-y-0.5`}
      >
        <Play className="h-6 w-6 text-greenaccent fill-greenaccent" strokeWidth={0} />
        <span className="text-left leading-tight">
          <span className="block text-[10px] uppercase tracking-widest text-white/60">Get it on</span>
          <span className="block font-display text-base font-600 font-semibold">Google Play</span>
        </span>
        <span className="ml-2 rounded-full bg-greenaccent/20 px-2 py-0.5 text-[10px] font-semibold text-greenaccent">Available Now</span>
      </a>

      <button
        type="button"
        disabled
        data-testid="app-store-coming-soon-btn"
        aria-label="RenewTracker coming soon on the App Store"
        className={`group relative flex items-center gap-3 rounded-2xl bg-ink text-white ${pad} opacity-70 cursor-not-allowed shadow-sm`}
      >
        <Apple className="h-6 w-6" />
        <span className="text-left leading-tight">
          <span className="block text-[10px] uppercase tracking-widest text-white/60">Coming soon on the</span>
          <span className="block font-display text-base font-semibold">App Store</span>
        </span>
        <span className="ml-2 rounded-full bg-greenaccent/20 px-2 py-0.5 text-[10px] font-semibold text-greenaccent">Soon</span>
      </button>
    </div>
  );
};

export default StoreButtons;
